var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentageWheelIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 25,
    viewBox: "0 0 48 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "greenBar",
    d: "M35.9173 6.38485C36.6051 5.37027 37.993 5.09767 38.9387 5.87738C41.3256 7.84516 43.3097 10.2663 44.7721 13.0084C46.2345 15.7506 47.1395 18.7471 47.4438 21.8256C47.5643 23.0454 46.5647 24.046 45.339 24.0519C44.1132 24.0578 43.128 23.0656 42.9811 21.8487C42.6967 19.4925 41.9782 17.2026 40.8554 15.0972C39.7326 12.9918 38.2314 11.1193 36.4332 9.57034C35.5045 8.77037 35.2294 7.39942 35.9173 6.38485Z",
    fill: "#60C67C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "redBar",
    d: "M2.40103 24.1553C1.17529 24.1553 0.170843 23.1594 0.285517 21.9391C0.577368 18.8332 1.48065 15.8079 2.95124 13.0402C4.42183 10.2725 6.42342 7.83076 8.83398 5.85063C9.78115 5.0726 11.1686 5.34767 11.8546 6.36347C12.5406 7.37926 12.2631 8.74972 11.333 9.54804C9.51595 11.1076 8.00072 12.9969 6.87107 15.123C5.74142 17.249 5.02371 19.5621 4.74824 21.9407C4.60722 23.1583 3.62677 24.1553 2.40103 24.1553Z",
    fill: "#fda6b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "orangeBar",
    d: "M13.2507 5.49703C12.6444 4.43172 13.0131 3.06619 14.1305 2.56224C17.201 1.17734 20.5399 0.459641 23.9253 0.467574C27.3106 0.475502 30.6461 1.20884 33.7102 2.6081C34.8251 3.11728 35.1874 4.48453 34.5761 5.54698C33.9649 6.60943 32.6118 6.96212 31.4861 6.47714C29.1016 5.44986 26.5265 4.91248 23.9149 4.90637C21.3032 4.90025 18.7256 5.42555 16.3363 6.44165C15.2084 6.92135 13.857 6.56233 13.2507 5.49703Z",
    fill: "#ffccaf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageWheelIconGreen);
export default __webpack_public_path__ + "static/media/percentageWheelIconGreen.5d235caab04d479497a62e25ff69ec05.svg";
export { ForwardRef as ReactComponent };